import { createAsyncThunk } from "@reduxjs/toolkit";
import { Api } from "service/api/Api";
import { ApiServidores, ServidoresQueryParams } from "service/api/ufc/ApiServidores";
import { RootState } from "store/store";
import { ErrosUtils } from "util/ErrosUtils";
import { OrdemColunaTabela } from "view/component/Tabela/model/OrdemColunaTabela";
import { BuscaServidoresFormularioType } from "view/section/BuscaServidoresSection/formulario/BuscaServidoresFormulario.types";
import { RestricaoUnidade } from "view/section/BuscaServidoresSection/formulario/RestricaoUnidadeSelect";
import { VinculoServidor } from "view/section/BuscaServidoresSection/formulario/VinculoServidorSelect";


export type TipoAcaoListaSolicitacao = 
  | 'novaBusca'
  | 'carregarPagina'
  ;

type ListaServidoresType = {
  queryParams?: ServidoresQueryParams;
  ordem?: OrdemColunaTabela;
  acao: TipoAcaoListaSolicitacao;
  pagina: number;
}


class ListaAction {
  static readonly iniciar = (formulario: BuscaServidoresFormularioType) => {
    const queryParams = gerarQueryParams(formulario);
    return ListaAction._carregar({acao: 'novaBusca', pagina: 1, queryParams: queryParams});
  }

  static readonly alterarOrdem = (pagina: number, ordem: OrdemColunaTabela) => {
    return ListaAction._carregar({acao: 'carregarPagina', pagina: pagina, ordem: ordem});
  }

  static readonly carregarPagina = (pagina: number) => {
    return ListaAction._carregar({acao: 'carregarPagina', pagina: pagina});
  }
  
  static readonly _carregar = createAsyncThunk(
    'Servidores/lista/carregar',
    async ({queryParams, pagina, ordem}: ListaServidoresType, {getState, rejectWithValue}) => {
      const { servidores } = getState() as RootState;

      const queryParamsConsulta = queryParams ?? servidores.filtros;
      const ordemConsulta = ordem ?? servidores.ordem;

      try {
        return await ApiServidores.getServidores(Api.REINO_PADRAO, pagina, queryParamsConsulta, ordemConsulta);
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  ) 
}


function gerarQueryParams(formulario: BuscaServidoresFormularioType): ServidoresQueryParams {
  const idUnidade = formulario.unidadeExercicio as number;
  const isSuperUnidade = formulario.restricaoUnidade === RestricaoUnidade.BUSCA_ESTA_UNIDADE_E_SUB_UNIDADES;

  return {
    nome: formulario.nome,
    situacao: formulario.situacao === VinculoServidor.ATIVO,
    idUnidadeExercicio: isSuperUnidade ? undefined : idUnidade,
    idSuperUnidadeExercicio: isSuperUnidade ? idUnidade : undefined,
  }
}

export class ServidoresAction {
  public static readonly lista = ListaAction;
}